import { createSimpleContext } from "@openanalyst-ai/ui/context"
import { useSDK } from "./sdk"
import { useServerSync } from "./server-sync"

export { applyOptimisticAdd, applyOptimisticRemove, mergeOptimisticPage } from "./directory-sync"

export const { use: useSync, provider: SyncProvider } = createSimpleContext({
  name: "Sync",
  init: () => {
    const sdk = useSDK()
    const serverSync = useServerSync()
    return serverSync.createDirSyncContext(sdk.directory)
  },
})
